import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SupplierService } from '../../../services/supplier.service';
import { IRFQTemplateDetail } from 'src/app/modules/pr-buyer/models';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-supplier-rfq-accept-reject',
  templateUrl: './supplier-rfq-accept-reject.component.html',
  styleUrls: ['./supplier-rfq-accept-reject.component.scss']
})
export class SupplierRfqAcceptRejectComponent implements OnInit {

  public rfqTemplateDetail!: IRFQTemplateDetail;


  constructor(public bsModalRef: BsModalRef, public _supplierService:SupplierService,public _authService:AuthService,private router:Router) { }

  ngOnInit(): void {
  }

  public submit(type:string){
    console.log(type);
    if(type == 'decline'){
      const payload = {
        template_id: this.rfqTemplateDetail.id,
        vendor_code: this._authService.getUserId(),
        status: "Declined to Participate"
      }
      this._supplierService.supplierAcceptOrReject(payload).subscribe((res:any)=>{
        this.bsModalRef.hide();
      })
    } else {
      const payload = {
        template_id: this.rfqTemplateDetail.id,
        vendor_code: this._authService.getUserId(),
        status: "Intended to Participate"
      }
      this._supplierService.supplierAcceptOrReject(payload).subscribe((res:any)=>{
        this.router.navigateByUrl("/supplier/rfq/"+this.rfqTemplateDetail.id)
        this.bsModalRef.hide();
      })
    }
  }

}
